export default __webpack_public_path__ + "static/media/logo.c9dbf68d.png";